global.Date = class extends Date {
  constructor(date = 'December 25, 2020 12:42:00 GMT-0500') {
    super(date);
  }
};